import { Dropdown, Flex, Menu, Tooltip, Typography } from "antd";
import {
  ClockCircleOutlined,
  DownOutlined,
  SettingOutlined,
  StopOutlined,
} from "@ant-design/icons";
import {
  BREAKDOWN_SETTINGS,
  SHIFT_SETTING,
  TIME_WISE_GRAPH_REPORTS,
} from "../../constants/routes";
import { getUrl } from "../../utilities/helpers";
import get from "lodash/get";
import find from "lodash/find";
import map from "lodash/map";

import { useEffect, useState } from "react";

const {Paragraph} = Typography;

const buttonConfig = {
  time_graph_reports: {
    title: "Time Reports",
    icon: <ClockCircleOutlined />,
    route: TIME_WISE_GRAPH_REPORTS,
  },
  breakdown: {
    title: "Breakdown",
    icon: <StopOutlined />,
    route: BREAKDOWN_SETTINGS,
  },
  shift: {
    title: "Shift settings",
    icon: <SettingOutlined />,
    route: SHIFT_SETTING,
  },
};

const DashboardTemplateButton = ({ title, template }) => {
  const config = buttonConfig[title];

  if (!config) return null;

  const handleClick = () => {
    const url = getUrl(config.route, {
      company_uuid: get(template, "company.id"),
      template_type: get(template, "type.value"),
      template: get(template, "id"),
    });
    window.open(url, "_blank");
  };

  return (
    <Tooltip title={config.title}>
      <button
        className="p-2 flex items-center justify-center text-[14px] bg-orange-400 rounded-full text-white hover:bg-orange-300"
        onClick={handleClick}
      >
        {config.icon}
      </button>
    </Tooltip>
  );
};

export default DashboardTemplateButton;

export const DashboardTemplateDropdown = ({
  themeClasses,
  stats,
  setPart,
  part,
}) => {
  const [selectedPartName, setSelectedPartName] = useState(get(part, "name"));

  const handleMenuClick = (e) => {
    const clickedPartName = e.key;
    setSelectedPartName(clickedPartName);
    const part = find(get(stats, "parts"), ["name", clickedPartName]);
    setPart(part);
  };

  const menuItems = map(get(stats, "parts"), (item) => ({
    key: get(item, "name"),
    label: get(item, "name"),
    className: "text-xs !text-white",
  }));

  useEffect(() => {
    setSelectedPartName(get(part, "name"));
  }, [part]);
  return (
    <Flex
      justify="center"
      align="center"
      className={`py-2 px-4 items-center justify-center w-full`}
    >
      {get(stats, "parts", []).length > 1 ? (
        <Dropdown
          popupRender={() => (
            <Menu
              onClick={handleMenuClick}
              items={menuItems}
              itemRender={(item) => (
                // <Tooltip title={item.label}>
                <Paragraph className="!text-xs text-neutral-20 !mb-0"  style={{color:"#fff", marignBottom:0, width:100}}>{item.label}</Paragraph>
                // </Tooltip>
              )}
              className="my-dark-menu"
            />
          )}
          overlayClassName="my-dark-dropdown-overlay"
        >
          <Flex
            justify="between"
            className="border-b border-neutral-800 border-solid w-full text-neutral-200 hover:text-white"
          >
            <Flex className="pb-2 px-2 w-full" align="center">
              <Tooltip title={selectedPartName}>

              <Paragraph ellipsis={{rows:1, expandable:false}} style={{color:"#fff", marignBottom:0, width:130}} className="!text-xs !mb-0 text-center">{selectedPartName}</Paragraph>
              </Tooltip>
              <Flex className="ml-auto" align="center" justify="center">
                <DownOutlined />
              </Flex>
            </Flex>
          </Flex>
        </Dropdown>
      ) :
        (
          <Flex
            justify="between"
            className={`border-b border-neutral-800 border-solid w-full text-neutral-200 hover:text-white items-center justify-center ${get(
        themeClasses,
        "mainBorder"
      )}`}
          >
            <Flex className="pb-2 px-2 w-full text center" justify="center" align="center">
              <Tooltip title={selectedPartName}>

              <Paragraph ellipsis={{rows:1, expandable:false}} style={{color:"#fff", marignBottom:0, width:130}} className="!text-xs !mb-0 text-center">{selectedPartName||"--"}</Paragraph>
              </Tooltip>
            </Flex>
          </Flex>
        )}

    </Flex>
  );
};